/** Spoločná logika obdobia pre náhľad a drill-down do zoznamu (parita FP). */

export function getYesterdayISO() {
  const t = new Date();
  t.setDate(t.getDate() - 1);
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`;
}

export function toLocalDateString(d) {
  if (!d || !(d instanceof Date) || Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * @param {string} timePeriod
 * @param {Date|Date[]|null} date
 * @returns {{ from: string|null, to: string|null }}
 */
export function getPreviewDateRange(timePeriod, date) {
  if (!date) return { from: null, to: null };
  const lastDayStr = getYesterdayISO();
  let from;
  let to;
  if (timePeriod === 'Za deň') {
    const s = toLocalDateString(date instanceof Date ? date : new Date(date)) ?? '';
    from = s;
    to = s;
  } else if (timePeriod === 'Za mesiac') {
    const d = new Date(date);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const lastDay = new Date(y, d.getMonth() + 1, 0).getDate();
    from = `${y}-${m}-01`;
    to = `${y}-${m}-${String(lastDay).padStart(2, '0')}`;
  } else if (timePeriod === 'Za rok') {
    const y = new Date(date).getFullYear();
    from = `${y}-01-01`;
    to = `${y}-12-31`;
  } else if (timePeriod === 'Vlastné' && Array.isArray(date) && date.length >= 2) {
    from = toLocalDateString(new Date(date[0])) ?? '';
    to = toLocalDateString(new Date(date[1])) ?? '';
  } else {
    return { from: null, to: null };
  }
  if (to && to > lastDayStr) to = lastDayStr;
  if (from && to && from > to) return { from: lastDayStr, to: lastDayStr };
  return { from, to };
}

export const PREVIEW_PERIOD_SEGMENTS = Object.freeze(['pribudlo', 'nevyriesene', 'ukoncene']);
